import { useCallback, useEffect, useState } from 'react';

async function fetchExhibitions() {
  const r = await fetch('/api/shows.php');
  const data = await r.json().catch(() => ({}));
  if (!data.ok) {
    return { status: 'error', upcoming: [], recent: [] };
  }
  return {
    status: 'ready',
    upcoming: Array.isArray(data.upcoming) ? data.upcoming : [],
    recent: Array.isArray(data.recent) ? data.recent : [],
  };
}

/**
 * Single fetch for home exhibition banner + section (upcoming is soonest first per API).
 */
export function useExhibitions() {
  const [state, setState] = useState({
    status: 'loading',
    upcoming: [],
    recent: [],
  });

  const refetch = useCallback(async () => {
    try {
      const next = await fetchExhibitions();
      setState(next);
      return next;
    } catch {
      setState({ status: 'error', upcoming: [], recent: [] });
      return { status: 'error', upcoming: [], recent: [] };
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const next = await fetchExhibitions();
        if (!cancelled) setState(next);
      } catch {
        if (!cancelled) setState({ status: 'error', upcoming: [], recent: [] });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { ...state, refetch };
}
